import React  from 'react';
import {makeStyles} from '@material-ui/core'
import { BsGithub, BsInstagram, BsGoogle, BsLinkedin } from "react-icons/bs";

import './footer.scss';


const useStyles = makeStyles({

    footerStyles: {
      color: 'white',
      background: '#0000',
      textAlign: 'center',
      justifyContent: 'space-between',
      
    },
    linkContainer: {
      display: 'flex',
      justifyContent: 'space-around',
    },
    links: {
      display: 'flex',
      flexDirection: 'column',
      padding: '2%',
      paddingTop: '1%',
    },
    title:{
        marginBottom:'8%',
    },
    redes: {
        display: 'flex',
        flexDirection: 'row',
        padding: '2%',
        paddingTop: '1%',
        alignItems: 'center',
      },
    btns:{
        fontSize: '2.5rem',
        padding: '3%',
    },
    aStyles: {
      color:'white',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      },
      lineHeight: '180%'
    },
    bottom: {
      textAlign: 'center',
      padding: '1%'
    }
  })
  

export default function Footer() {

    const classes = useStyles();
  
    return (
        
        <footer className={classes.footerStyles}>
            <div className={classes.linkContainer}>
                <div className={classes.links}>
                <h3 className={classes.title}>Created with</h3>
                <a href='https://www.themoviedb.org/' ><img src={"https://www.themoviedb.org/assets/2/v4/logos/v2/blue_square_1-5bdc75aaebeb75dc7ae79426ddd9be3b2be1e342510f8202baf6bffa71d7f5c4.svg"} alt="" /></a>
                </div>
                <div className={classes.links}>
                <h3 >Created by</h3>
                <a href='https://danielaescudero.netlify.app/' className={classes.aStyles}>Daniela Escudero</a>
                <a href='mailto:danielasolescudero@gmail.com' className={classes.aStyles}>danielasolescudero@gmail.com</a>
                <a href='https://api.whatsapp.com/send/?phone=5491137950122&text&type=phone_number&app_absent=0' className={classes.aStyles}>+54 911 37950122</a>
                </div>
                <div className={classes.redes}>
                    <a className={classes.btns} href="mailto:danielasolescudero@gmail.com"role="button"><BsGoogle /></a>
                    <a className={classes.btns} href="https://instagram.com/trish_digital?igshid=YmMyMTA2M2Y="role="button"> <BsInstagram /></a>
                    <a className={classes.btns} href="https://www.linkedin.com/in/daniela-s-escudero/" role="button"><BsLinkedin /></a>
                    <a className={classes.btns} href="https://github.com/DanielaSEscudero" role="button"><BsGithub /></a>  
                </div>
            </div>
            <h5 className={classes.bottom}>Copyright &reg; 2023. All rights reserved.</h5>
        </footer>
    );
}




